<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>
            검색 조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>행사명</th>
              <td>
                <input v-focus type="text" v-model="answerAttendQueryData.eventNm" v-on:keyup.enter="sendQuery"/>
              </td>
              <th>교우명</th>
              <td>
                <input type="text" v-model="answerAttendQueryData.memberHnm" v-on:keyup.enter="sendQuery"/>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="sendQuery">
            <md-icon>check</md-icon>검 색</md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
            <md-icon>clear</md-icon>
            초기화
          </md-button>
          <md-button class="md-default md-sm" @click="deleteAnswerList">
            <md-icon>clear</md-icon>삭제
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>
            Excel 다운로드
          </md-button>
        </md-card-actions>
      </md-card>

      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>
            검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ pagination.total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </div>
          <grid ref="answerAttendListGrid"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @response="response"
          ></grid>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaApi from "@/kuaa/kuaa-api";
import session from "@/kuaa/kuaa-sessions";
import axios from "axios";
import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import moment from "moment";

export default {
  components: {
    grid: Grid
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  created() {
    this.initGrid();
  },

  data() {
    return {
      answerAttendQueryData : {
        "eventNm": "", // 행사명
        "memberHnm": "" // 교우명
      },

      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    }
  },

  methods: {
    sendQuery (){
      let option = {
        eventNm: this.answerAttendQueryData.eventNm,
        memberHnm: this.answerAttendQueryData.memberHnm
      };
      this.$refs.answerAttendListGrid.invoke("readData", 1, option);
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_ANSWER_ATTEND_LIST, false, this.pagination, ['rowNum', 'checkbox']);
      this.gridProps['el'] = this.$refs.answerAttendListGrid;
      this.gridProps['columns'] = [
          {header: '교우번호', name: 'memberNo', align:'center', sortable: true},
          {header: '교우명', name: 'memberHnm', align:'center', sortable: true},
          {header: '학과', name: 'classNm', align:'center', sortable: true},
          {header: '학번', name: 'hakbun', align:'center', sortable: true},
          {header: '행사명', name: 'eventNm', align:'center', sortable: true},
          {header: '참석여부', name: 'attendYn', align:'center', sortable: true},
          {header: '남기신말씀', name: 'remark', align:'center'},
          {header: '등록일시', name: 'insertDate', align:'center', sortable: true,
            formatter(value) {
              if (!value.value) {
                return '';
              }

              return moment(value.value).format('YYYY-MM-DD');
            }
          }
        ];
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.answerAttendListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    downloadExcel() {
      this.answerAttendQueryData.page = 1;
      this.answerAttendQueryData.perPage = this.pagination.total;
      this.answerAttendQueryData.fileName = '행사참여응답';
      kuaaApi.requestFileDownload(
          URL_CONST.EVENT_REPLY_EXCEL_DOWNLOAD,
          this.answerAttendQueryData,
          '행사참여응답.xlsx',
          response => {
            this.answerAttendQueryData.page = this.pagination.page;
            this.answerAttendQueryData.perPage = this.pagination.perPage;
          }
      );
    },
    clearQuery() {
      this.answerAttendQueryData = {
        eventNm: "",
        memberHnm: ""
      };
    },

    deleteAnswerList() {
      let checkedRows = this.$refs.answerAttendListGrid.invoke('getCheckedRows');

      if(checkedRows.length < 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'행사참여 응답을 선택 해 주세요'}));
        return;
			}

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "행사참여 응답을 삭제 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.DELETE_ANSWER_ATTEND_LIST,
            checkedRows,
            "post",
            response => {
              let modalOptions = kuaaFnc.getSwalModaloptions();
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.sendQuery();
              } else {
                modalOptions.html = `행사참여 응답 삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );

        }
      });
    },    
  }
}
</script>

<style scoped>

</style>